export enum EClasse {
    Risque2 = 2,
    Risque3 = 3,
    Risque4 = 4,
    Risque2_2003 = 5,
    Risque3_2003 = 6,
    Risque4_2003 = 7,
    // BPPClasseA = 8,
    // BPPClasseB = 9,
    // BPPClasseC = 10,
    // BPPClasseD = 11,
    // BPPH = 12,
}
